import React from 'react';

export default ({ isHidden }) => !isHidden && null;
